/* tslint:disable */
/* eslint-disable */

/**
 * 0 = EnAttente
 * 1 = EnCours
 * 2 = Terminee
 */
export enum StatutNettoyage {
  EnAttente = 0,
  EnCours = 1,
  Terminee = 2
}
